import EchartsComponents from './Echarts.vue';

const Echarts = {
    install:function(Vue) {
        Vue.component('Echarts', EchartsComponents)
    }
}

export default Echarts;


// WEBPACK FOOTER //
// ./src/components/Echarts/index.js